<template>
  <div style="padding: 30px">
    <div class="d-flex justify-space-between align-center mb-4">
      <h2 class="text-h5">Processing Profiles</h2>
      <v-btn color="primary" @click="fetchFromApi" :loading="fetching" class="text-capitalize">
        <v-icon left>{{ icons.mdiDownload }}</v-icon>
        Fetch from Etsy API
      </v-btn>
    </div>

    <v-data-table :headers="headers" :items="profiles" :items-per-page="10" class="elevation-1 mt-5">
      <template v-slot:top>
        <v-row style="padding: 10px">
          <v-col md="2" cols="6">
            <strong>Total: </strong> {{ profiles.length }}
          </v-col>
        </v-row>
      </template>
      <template v-slot:body="{ items }">
        <tbody v-if="!is_loading">
          <tr v-if="!items.length">
            <td colspan="5" class="text-center" style="padding: 20px 0px">
              <img :src="require('@/assets/images/misc/no-data.png')" alt="" width="250px" />
              <p style="font-size: 25px">No Data Found!!</p>
            </td>
          </tr>
          <tr v-for="item in items" :key="item.readiness_state_id">
            <td>{{ item.readiness_state_id }}</td>
            <td>
              {{ item.readiness_state }}
              <v-chip small class="ma-2" color="primary" v-if="item.is_default" text-color="white">
                <v-icon small left>{{ icons.mdiStar }}</v-icon>
                Default
              </v-chip>
            </td>
            <td>{{ item.min_processing_days }} - {{ item.max_processing_days }} days</td>
            <td>{{ item.processing_days_display_label }}</td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr>
            <td colspan="5" class="text-center" style="padding: 80px 0px">
              <img :src="require('@/assets/images/misc/loading.gif')" alt="" width="100px" />
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import store from '@/store'
import { mdiDownload, mdiStar } from '@mdi/js'

export default {
  data() {
    return {
      shop: null,
      is_loading: false,
      fetching: false,
      profiles: [],
      headers: [
        { text: 'State ID', value: 'readiness_state_id' },
        { text: 'Readiness State', value: 'readiness_state' },
        { text: 'Processing Days', value: 'min_processing_days' },
        { text: 'Display Label', value: 'processing_days_display_label' },
      ],
      icons: {
        mdiDownload: mdiDownload,
        mdiStar: mdiStar,
      },
    }
  },
  mounted() {
    this.shop = store.getters.loggedInShop
    this.fetchProfiles()
  },
  methods: {
    async fetchProfiles() {
      try {
        this.is_loading = true
        let response = await axios.get(`/admin/shops/${this.shop.id}/processing-profiles`)
        if (response.data.success) {
          this.profiles = response.data.data || []
        }
      } catch (e) {
        console.error('Error fetching processing profiles:', e)
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch processing profiles',
        })
      } finally {
        this.is_loading = false
      }
    },
    async fetchFromApi() {
      try {
        this.fetching = true
        let response = await axios.get(`/admin/shops/${this.shop.id}/processing-profiles/fetch`)
        if (response.data.success) {
          this.$swal.fire({
            icon: 'success',
            title: 'Success',
            text: response.data.message || 'Processing profiles fetched successfully',
          })
          await this.fetchProfiles()
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: response.data.message || 'Failed to fetch processing profiles',
          })
        }
      } catch (e) {
        console.error('Error fetching from API:', e)
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch processing profiles from Etsy API',
        })
      } finally {
        this.fetching = false
      }
    },
  },
}
</script>


